import { RainfallSurfaceResult } from "./renderSurface";

const MAX_SURFACE_CACHE_ENTRIES = 12;

const surfaceCache = new Map<string, RainfallSurfaceResult>();

export function buildRainfallSurfaceCacheKey(parts: {
  stationsKey: string;
  bandsKey: string;
  selectedCodesKey: string;
  boundsKey: string;
  clipKey: string;
  width: number;
  height: number;
  power: number;
  opacity: number;
  maxDistanceDegrees: number;
  edgeFeatherRatio: number;
  blurPx: number;
  valueBlurRadius?: number;
}): string {
  return [
    parts.stationsKey,
    parts.bandsKey,
    parts.selectedCodesKey,
    parts.boundsKey,
    parts.clipKey,
    parts.width,
    parts.height,
    parts.power,
    parts.opacity,
    parts.maxDistanceDegrees.toFixed(6),
    parts.edgeFeatherRatio.toFixed(3),
    parts.blurPx.toFixed(2),
    (parts.valueBlurRadius ?? 0).toFixed(2),
  ].join("|");
}

export function getCachedRainfallSurface(
  key: string
): RainfallSurfaceResult | undefined {
  const hit = surfaceCache.get(key);
  if (!hit) {
    return undefined;
  }


  surfaceCache.delete(key);
  surfaceCache.set(key, hit);
  return hit;
}

export function setCachedRainfallSurface(
  key: string,
  value: RainfallSurfaceResult
): void {
  if (surfaceCache.has(key)) {
    surfaceCache.delete(key);
  }
  surfaceCache.set(key, value);

  while (surfaceCache.size > MAX_SURFACE_CACHE_ENTRIES) {
    const oldestKey = surfaceCache.keys().next().value;
    if (oldestKey === undefined) {
      break;
    }
    surfaceCache.delete(oldestKey);
  }
}

export function clearRainfallSurfaceCache(): void {
  surfaceCache.clear();
}

export function getRainfallSurfaceCacheSize(): number {
  return surfaceCache.size;
}
